var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7671 12.7975H9.74673H9.2027H9.08521V10.0875H9.9715C10.1963 10.0875 10.3291 9.83211 10.1963 9.64821L8.47221 7.26263C8.36238 7.10938 8.13506 7.10938 8.02523 7.26263L6.30118 9.64821C6.16837 9.83211 6.29863 10.0875 6.52595 10.0875H7.41224V12.7975H7.29475H6.75072H4.40856C3.06763 12.7234 2 11.4693 2 10.1105C2 9.17313 2.50828 8.35581 3.26175 7.91394C3.19279 7.72749 3.15703 7.52826 3.15703 7.31882C3.15703 6.36102 3.93094 5.58711 4.88874 5.58711C5.09563 5.58711 5.29485 5.62287 5.4813 5.69183C6.03555 4.51692 7.2309 3.70215 8.62035 3.70215C10.4185 3.7047 11.8999 5.08139 12.0685 6.83609C13.4502 7.07362 14.5 8.35325 14.5 9.80146C14.5 11.3493 13.2944 12.6902 11.7671 12.7975Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.2a4b23d539fc9c115bd8efb41844d52a.svg";
export { ForwardRef as ReactComponent };